module.exports = __webpack_public_path__ + "static/media/yak.dd2188f2.png";